import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ServiceDTO } from '@/features/services/api';

interface ServiceCardProps {
  service: ServiceDTO;
  examCount: number | undefined;
  onEdit: () => void;
  onDelete: () => void;
}

export function ServiceCard({ service, examCount, onEdit, onDelete }: ServiceCardProps) {
  const fixed = service.fixedShiftValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  return (
    <article
      className="flex items-center gap-4 rounded-lg border border-(--color-border) bg-(--color-surface) p-4"
      aria-label={`Serviço ${service.name}`}
    >
      <div
        aria-hidden
        className="h-12 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: service.color }}
      />
      <div className="min-w-0 flex-1">
        <h3 className="truncate font-display text-base font-semibold text-(--color-fg)">
          {service.name}
        </h3>
        <p className="mt-0.5 text-xs text-(--color-fg-muted)">
          Valor fixo: <span className="tabular-nums">{fixed}</span>
          {typeof examCount === 'number' ? (
            <> · {examCount} {examCount === 1 ? 'exame' : 'exames'}</>
          ) : null}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Button size="icon" variant="ghost" aria-label={`Editar ${service.name}`} onClick={onEdit}>
          <Pencil className="h-4 w-4" />
        </Button>
        <Button
          size="icon"
          variant="ghost"
          aria-label={`Excluir ${service.name}`}
          onClick={onDelete}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </article>
  );
}
